import { getCallingCodeForIso } from '@/utils/formatters/phoneCountryCode';
import {
	formatNationalNumber,
	splitPhoneNumber
} from '@/utils/formatters/phoneNumberParts';

export const formatPhoneNumber = (
	phoneNumber: string | null | undefined,
	country?: string | null
): string => {
	if (!phoneNumber) return '';

	const { countryIso, nationalNumber } = splitPhoneNumber(phoneNumber, country);
	const formattedNational = formatNationalNumber(countryIso, nationalNumber);

	const callingCode = getCallingCodeForIso(countryIso);
	return callingCode
		? `+${callingCode} ${formattedNational}`
		: formattedNational;
};
